import React, { useCallback, useContext } from "react";
import { EnumNotificationStatus } from "./NotificationsPage";
import Notification from "./Notification";
import SocketContext from "../../providers/Socket";
import useConfig from "../../hooks/use-config";
import FlatList from 'flatlist-react';
import { NotificationsLoader } from "../UI/NotificationsLoader/NotificationsLoader";
import { isShobiddak } from "../../helpers/commonFunctions";
const Notifications = (props) => {
    var _a;
    const { notifications, setNotifications } = props;
    const { socket } = useContext(SocketContext);
    const config = useConfig();
    const onClick = useCallback((timelineId, eventId) => {
        if (!socket)
            return;
        setNotifications(prevNotifications => {
            const foundIndex = prevNotifications.findIndex(it => it.timeline_id == timelineId);
            prevNotifications[foundIndex] = Object.assign(Object.assign({}, prevNotifications[foundIndex]), { status: EnumNotificationStatus.CLICKED });
            return prevNotifications.slice();
        });
        socket === null || socket === void 0 ? void 0 : socket.emit('event-update', {
            timeline_id: timelineId, event_id: eventId, status: 80
        });
    }, [socket, setNotifications]);
    const lang = (_a = config.lang) !== null && _a !== void 0 ? _a : 'ar';
    const nowText = (lang == 'ar') ? 'الأن' : 'now';
    const minutesText = (lang == 'ar') ? 'دقيقة' : 'minutes';
    const hoursText = (lang == 'ar') ? 'ساعات' : 'hours ago';
    function timeSince(date, sentDate) {
        var today = new Date(sentDate);
        var d = new Date(sentDate), month = '' + (d.getMonth() + 1), day = '' + d.getDate(), year = d.getFullYear();
        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        // const yyyy = today.getFullYear();
        // let mm = (today.getMonth() + 1).toString();
        // let dd = today.getDate().toString();
        // if (dd < '10') dd = `0${dd}`
        // if (mm < '10') mm = `0${mm}`
        const formattedToday = day + '-' + month + '-' + year;
        // // var day = today.getDay().toString();
        // // if (day < '10') {
        // //     day  =  `0${day}`;
        // // }
        // // var month = today.getMonth().toString();
        // // if (month < '10') {
        // //     month = `0${month}`;
        // // }
        // var newFormateData = day + '-' + month + '-' +today.getFullYear()
        const newDate = new Date();
        var seconds = Math.floor((newDate - date) / 1000);
        var interval = seconds / 31536000;
        if (interval > 1) {
            return formattedToday;
            return Math.floor(interval) + " years ago";
        }
        interval = seconds / 2592000;
        if (interval > 1) {
            return formattedToday;
            return Math.floor(interval) + " months ago";
        }
        interval = seconds / 86400;
        if (interval > 1) {
            return formattedToday;
            return Math.floor(interval) + " days ago";
        }
        interval = seconds / 3600;
        if (interval > 1) {
            return Math.floor(interval) + ` ${hoursText}`;
        }
        interval = seconds / 60;
        if (interval > 1) {
            return Math.floor(interval) + ` ${minutesText}`;
        }
        if (interval < 0 || interval == 0) {
            return nowText;
        }
        else {
            return nowText;
        }
    }
    function dateToYMD(date) {
        var d = date.getDate();
        var m = date.getMonth() + 1;
        var y = date.getFullYear();
        return '' + y + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
    }
    if (props.load)
        return React.createElement("div", { className: `row justify-content-center align-items-center` },
            React.createElement(NotificationsLoader, null));
    return React.createElement(React.Fragment, null,
        React.createElement(FlatList, { list: notifications, renderItem: (item, key) => {
                const notification = item;
                const timestamp = dateToYMD(new Date(notification.sent_at));
                const date = timeSince(notification.sent_at, timestamp);
                const hideNotification = (item.notification_name.includes('unread_chat_messages') || item.cta_1.link.includes('/chatCenter') || item.cta_2.link.includes('/chatCenter') || item.cta_3.link.includes('/chatCenter')) && isShobiddak();
                return (hideNotification ? React.createElement(React.Fragment, null)
                    : React.createElement(Notification, { notification: notification, onView: onClick, date: date, NotificationViewComponent: props.NotificationItem, key: key }));
            }, renderWhenEmpty: () => React.createElement(React.Fragment, null) }));
};
export default Notifications;
